// @ts-ignore
import cssHasPseudo from "css-has-pseudo/browser";

try {
    // perform a feature detection of has pseudo polyfill since its quite expensive
    if (!window.CSS?.supports?.("selector(:has(any))")) {
        /* expensive operation, should only be enabled when needed */
        const hasPseudoObserveHover =
            document.querySelector('script.product, script[class="page.style-guide"]') !== null;
        cssHasPseudo(document, { hover: hasPseudoObserveHover });
    }
} catch (e) {}
